module.exports = __webpack_public_path__ + "static/img/2-3.6252696.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/2-3.jpg
// module id = QXjT
// module chunks = 1